import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { HashRouter as Router, Redirect, Route } from "react-router-dom";
import Recognition from "./pages/Recognition";
import AuthStart from "./pages/AuthStart";
import AuthEnd from "./pages/AuthEnd";
import Logout from "./pages/Logout";
import "./app.css";
import userService from "services/user";
import { app } from "@microsoft/teams-js";
import AuthConsent from "pages/AuthConsent";

const StyledAppContainer = styled.div`
  height: 100%;
  padding: 25px 45px 20px 45px;
`;

export const CREATE_RECOGNITION = "/create-recognition";
export const AUTH_START = "/auth-start";
export const AUTH_END = "/auth-end";
export const LOGOUT = "/logout";
export const AUTH_CONSENT = "/auth-consent";

const App: React.FC = () => {
  const [root, setRoot] = useState(AUTH_START);
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    if (window.location.pathname === AUTH_CONSENT) {
      setRoot(AUTH_CONSENT);
    }
    userService
      .getCurrentUser()
      .then((user) => {
        if (user) {
          setRoot(CREATE_RECOGNITION);
        }

        setHasLoaded(true);
      })
      .catch(() => {
        app
          .initialize()
          .then(() => app.notifyFailure({ reason: app.FailedReason.Timeout }));
        setHasLoaded(true);
      });
  }, []);

  if (!hasLoaded) {
    return null;
  }

  return (
    <StyledAppContainer>
      <Router>
        <>
          <Route exact path="/">
            <Redirect to={root} />
          </Route>
          <Route exact path={AUTH_START} component={AuthStart} />
          <Route exact path={AUTH_END} component={AuthEnd} />
          <Route exact path={AUTH_CONSENT} component={AuthConsent} />

          <Route exact path={LOGOUT} component={Logout} />

          <Route exact path={CREATE_RECOGNITION} component={Recognition} />
        </>
      </Router>
    </StyledAppContainer>
  );
};

export default App;
